import { render, staticRenderFns } from "./BoGrape.vue?vue&type=template&id=1047c1cc&"
import script from "./BoGrape.vue?vue&type=script&lang=js&"
export * from "./BoGrape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports